module.exports = __webpack_public_path__ + "static/media/mockup-kanban-presentation.a37fd144.png";